"use strict";
exports.__esModule = true;
// формат для yasms https://doc.yandex-team.ru/Passport/YaSMSDevGuide/reference/sendsms.html#request__phone
var phoneRegEx = /^\+\d{11,14}$/;
var validatePhone = function (value) {
    return phoneRegEx.test(value) || !value ? '' : 'Введен некорректный номер телефона';
};
exports["default"] = validatePhone;
